export const USER_WISHLIST_ENDPOINT = "/user/wishlist";
export const GET_USER_ENDPOINT = "/user/me";
export const ALL_COURSE_CARD_ENDPOINT = "/course/cards/all";
export const COURSE_DETAIL_ENDPOINT = "/course/";
export const MENTOR_DETAIL_ENDPOINT = "/Mentor/get/";
export const GET_DOUBT_ENDPOINT = "/doubt";
export const USER_CART_ENDPOINT = "/user/cartList";
export const UPDATE_USER_ENDPOINT = "/user/update";
export const USER_ENROLLED_COURSE_ENDPOINT = "/user/enrolledCourses";
export const GET_DOUBT_DETAILS_ENDPOINT = "/doubt/get/";
